// libraries
import React from "react";
import { Link } from "react-router-dom";

// styles
import styles from "./styles.module.scss";

const Heading = ({ heading, to, link, handleClick }) => {
  return (
    <h1 className={styles.heading}>
      {heading}{" "}
      {to && (
        <span onClick={handleClick}>See all</span>
        // <Link to={to}>
        // </Link>
      )}
      {link && (
        <Link to={link}>
          <span onClick={handleClick}>See all</span>
        </Link>
      )}
    </h1>
  );
};

export default Heading;
